import React, { useState } from 'react';
import './Contact.css';

const WHATSAPP_NUMBER = '5524992095750';
const EMAIL = 'varellasambista@gmail.com';

// Redes sociais. Troque os href "#" pelas URLs reais — os marcados como "#"
// aparecem desativados em vez de virarem links quebrados.
const socialLinks = [
  { name: 'YouTube', url: 'https://www.youtube.com/playlist?list=PLxeNPdoj85lya1Y6HwQPvZOCZjski5ZbM' },
  { name: 'Instagram', url: '#' }, // TODO: inserir URL real
  { name: 'Facebook', url: 'https://www.facebook.com/antonio.sambista' },
  { name: 'Palco MP3', url: 'https://www.palcomp3.com.br/varellasambista/' }
];

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.1-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L8 9.6a16 16 0 0 0 6 6l1.2-1.2a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.7 2Z"/></svg>
);
const MailIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 6 10 7L22 6"/></svg>
);
const PinIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
);

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subjectLabels = {
      show: 'Contratação de Show',
      projeto: 'Projeto Artístico',
      parceria: 'Parceria',
      compra: 'Compra de Obra',
      outro: 'Outro'
    };
    const subjectText = subjectLabels[formData.subject] || formData.subject;
    const message = `Olá, Varella! 👋

📝 Nova mensagem do site:

👤 *Nome:* ${formData.name}
📧 *Email:* ${formData.email}
📞 *Telefone:* ${formData.phone || 'Não informado'}
📌 *Assunto:* ${subjectText}

💬 *Mensagem:*
${formData.message}`;

    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`, '_blank');
    setSubmitStatus('success');
    setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
  };

  const contactInfo = [
    { icon: <PhoneIcon />, title: 'Telefone', info: '+55 24 99209-5750', href: 'tel:+5524992095750', description: 'Shows e projetos' },
    { icon: <MailIcon />, title: 'Email', info: EMAIL, href: `mailto:${EMAIL}`, description: 'Propostas e parcerias' },
    { icon: <PinIcon />, title: 'Localização', info: 'Barra Mansa — RJ, Brasil', description: 'Atendimento presencial' }
  ];

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <span className="section-eyebrow">Vamos conversar</span>
        <h2 className="section-title">Entre em Contato</h2>
        <p className="section-subtitle">
          Disponível para shows, exposições, parcerias e venda de obras. A mensagem
          chega direto no WhatsApp do artista.
        </p>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-header-card">
              <img
                src="/sorrindocomamaopraesquerda.png"
                alt="Varella Sambista sorrindo"
                className="contact-portrait"
                loading="lazy"
              />
              <div className="contact-header-text">
                <h3>Informações de contato</h3>
                <p>Sempre aberto a novas parcerias, projetos e boas conversas sobre arte.</p>
              </div>
            </div>

            <div className="contact-details">
              {contactInfo.map((item, index) => (
                <div key={index} className="contact-item">
                  <span className="contact-icon">{item.icon}</span>
                  <div className="contact-text">
                    <h4>{item.title}</h4>
                    {item.href ? (
                      <a className="contact-main" href={item.href}>{item.info}</a>
                    ) : (
                      <p className="contact-main">{item.info}</p>
                    )}
                    <p className="contact-desc">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="social-links">
              <h4>Redes sociais</h4>
              <div className="social-grid">
                {socialLinks.map((social) => {
                  const disabled = social.url === '#';
                  return (
                    <a
                      key={social.name}
                      href={social.url}
                      target={disabled ? undefined : '_blank'}
                      rel="noopener noreferrer"
                      className={`social-link ${disabled ? 'is-soon' : ''}`}
                      aria-disabled={disabled}
                      onClick={(e) => disabled && e.preventDefault()}
                    >
                      {social.name}{disabled && <small> (em breve)</small>}
                    </a>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <h3>Envie uma mensagem</h3>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Nome *</label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleInputChange} required placeholder="Seu nome completo" />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} required placeholder="seu@email.com" />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">Telefone</label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleInputChange} placeholder="(24) 99999-9999" />
                </div>
                <div className="form-group">
                  <label htmlFor="subject">Assunto *</label>
                  <select id="subject" name="subject" value={formData.subject} onChange={handleInputChange} required>
                    <option value="">Selecione um assunto</option>
                    <option value="show">Contratação de Show</option>
                    <option value="projeto">Projeto Artístico</option>
                    <option value="parceria">Parceria</option>
                    <option value="compra">Compra de Obra</option>
                    <option value="outro">Outro</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="message">Mensagem *</label>
                <textarea id="message" name="message" value={formData.message} onChange={handleInputChange} required rows="5" placeholder="Conte sobre seu projeto ou interesse..."></textarea>
              </div>

              <button type="submit" className="btn submit-btn">Enviar via WhatsApp</button>

              {submitStatus === 'success' && (
                <div className="success-message">
                  <p>✅ Tudo certo! Abrimos o WhatsApp com sua mensagem. Em breve retornaremos.</p>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
